import $ from "jquery";
import { coreSearchModal } from './search-modal';



export default function coreSearchSidebarFilter(sidebar) {
    // If not provided, get whatever one is currently shown
    if (!sidebar) {
        let modal = new coreSearchModal();
        sidebar = modal.sidebarFilter();
    }
    // If a jQuery object wasn't provided, treat this as a selector
    if ('string' === typeof sidebar) {
        if ('#' === sidebar.charAt(0)) {
            sidebar = $(sidebar).first();
        } else {
            sidebar = $('#' + sidebar).first();
        }
    }
    // props
    this.id = sidebar.attr('id');
    this.jQueryObj = sidebar;

    this.unselectedWrapper = function () {
        return this.jQueryObj.find('.core-search-filter-unselected-options').first();
    };
    this.selectedWrapper = function () {
        return this.jQueryObj.find('.core-search-filter-selected-options').first();
    };
    this.unselectedOptionElements = function () {
        return this.unselectedWrapper().getAllFilterOptionElements();
    };
    this.unselectedOptionObjects = function () {
        return this.unselectedWrapper().getAllFilterOptionObjects();
    };
    this.selectedOptionElements = function () {
        return this.selectedWrapper().getAllFilterOptionElements();
    };
    this.selectedOptionObjects = function () {
        return this.selectedWrapper().getAllFilterOptionObjects();
    };
    this.reorderSelectedOptionElements = function () {
        let options = this.selectedOptionObjects();
        let selectedWrapper = this.selectedWrapper();
        options.sort(function (a, b) {
            return b.data.originalOrder - a.data.originalOrder;
        });
        options.reverse();
        options.forEach(function (option) {
            let formCheck = option.getFromSidebar(this);
            formCheck.appendTo(selectedWrapper);
        }, this);
    };
    this.reorderUnselectedOptionElements = function () {
        let options = this.unselectedOptionObjects();
        let unselectedWrapper = this.unselectedWrapper();
        options.sort(function (a, b) {
            return b.data.originalOrder - a.data.originalOrder;
        });
        options.reverse();
        options.forEach(function (option) {
            let formCheck = option.getFromSidebar(this);
            formCheck.appendTo(unselectedWrapper);
        }, this);
    };
    this.updateMobileOpenModalButtons = function () {
        if (this.jQueryObj.find('.core-search-option-checked').length) {
            this.jQueryObj.find('.core-search-mobile-input-empty').hide();
            this.jQueryObj.find('.core-search-mobile-modify-input').css('display', '');
        } else {
            this.jQueryObj.find('.core-search-mobile-modify-input').hide();
            this.jQueryObj.find('.core-search-mobile-input-empty').css('display', '');
        }
    };
    this.getCheckboxParent = function (parentId) {
        return this.jQueryObj.find('.core-search-form-check [value="' + parentId + '"]');
    };
    this.getCheckboxChildren = function (parentId) {
        return this.jQueryObj.find('.core-search-form-check[data-parent-id="' + parentId + '"] .form-check-input');
    };
    this.checkCheckboxAndAddToMobile = function (checkbox) {
        if (!checkbox.length) {
            return;
        }
        checkbox.prop('checked', true);
        let formCheck = checkbox.closest('.core-search-form-check');
        if (!formCheck.hasClass('core-search-option-checked')) {
            formCheck.addClass('core-search-option-checked');
        }

        // Add to search form as hidden input
        $('#core-search-form').prepend('<input type="hidden" name="' + checkbox.attr('name') + '" value="' + checkbox.val() + '">');

        // Also indent children
        let children = this.getCheckboxChildren(checkbox.val());
        this.indentCheckbox(children);
    };
    this.uncheckCheckboxAndRemoveFromMobile = function (checkbox) {
        if (!checkbox.length) {
            return;
        }
        checkbox.prop('checked', false);
        let formCheck = checkbox.closest('.core-search-form-check');
        formCheck.removeClass('core-search-option-checked');

        // Remove hidden input from searchform
        $('#core-search-form input[name="' + checkbox.attr('name') + '"][value="' + checkbox.val() + '"]').remove();

        // Also unindent children
        let children = this.getCheckboxChildren(checkbox.val());
        this.unindentCheckbox(children);
    };
    this.indentCheckbox = function (checkbox) {
        let formCheck = checkbox.closest('.core-search-form-check');
        formCheck.data('is-indented', '1');
        if (!formCheck.hasClass('core-search-mobile-modal-filter-indent')) {
            formCheck.addClass('core-search-mobile-modal-filter-indent');
        }
    }
    this.unindentCheckbox = function (checkbox) {
        let formCheck = checkbox.closest('.core-search-form-check');
        formCheck.data('is-indented', '').removeClass('core-search-mobile-modal-filter-indent');
    }
}

/* ******************************************************************** */
/*          Enable form submit button after any inputs change           */
/* ******************************************************************** */
$(function () {
    $(".core-search-results").on("change", "#core-search-sidebar-form .core-search-filter-box input", function () {
        $('.core-search-filter-submit').prop('disabled', false);
    });
});

/* ******************************************************************** */
/*              Expand side filter options (More/Less Buttons)          */
/* ******************************************************************** */
$(function () {
    $(".core-search-results").on("click", ".core-search-filter-more", function () {
        let $this = $(this);
        let filterBox = $($this.closest('.core-search-filter-box'));
        let shouldExpand = "false" === $(this).attr("aria-expanded");
        let controls = $('#' + $(this).data('controls'));
        if (shouldExpand) {
            controls.addClass('is-expanded');
            filterBox.addClass('is-expanded');
            $this.attr("aria-expanded", "true");
            $this.children('.core-search-filter-expand-text-more').text('Less');
            $this.children('.core-search-filter-expand-text-count').hide();
            $this.children('i').removeClass('fa-chevron-down').addClass('fa-chevron-up');
        } else {
            controls.removeClass('is-expanded');
            filterBox.removeClass('is-expanded');
            $this.attr("aria-expanded", "false");
            $this.children('.core-search-filter-expand-text-more').text('More');
            $this.children('.core-search-filter-expand-text-count').show();
            $this.children('i').addClass('fa-chevron-down').removeClass('fa-chevron-up');
        }
    });
});

/* ******************************************************************** */
/*             Check/uncheck ref type parents and children              */
/* ******************************************************************** */
$(function () {
    $(".core-search-results").on("change", ".core-search-filter-fields .form-check-input", function () {
        let checkbox = $(this);

        // Get sidebar object
        let sidebar = new coreSearchSidebarFilter(checkbox.closest('.core-search-filter-box'));

        // See if there is a parent-child relationship to update
        let formCheck = checkbox.closest('.core-search-form-check');
        let parentId = formCheck.data('parent-id');

        if (checkbox.is(':checked')) {
            sidebar.checkCheckboxAndAddToMobile(checkbox);

            // If this is a child, find all inputs with the same parent class. If they are all checked, check the parent. Otherwise uncheck the parent
            if (parentId) {
                let allChildren = sidebar.getCheckboxChildren(parentId);
                let allChecked = true;
                for (let i = 0; i < allChildren.length; i++) {
                    if (!$(allChildren[i]).prop('checked')) {
                        allChecked = false;
                    }
                }
                if (allChecked) {
                    sidebar.checkCheckboxAndAddToMobile(sidebar.getCheckboxParent(parentId));
                }
            } else {
                // If this is a parent, check all children
                sidebar.checkCheckboxAndAddToMobile(sidebar.getCheckboxChildren(checkbox.val()));
            }
        } else {
            sidebar.uncheckCheckboxAndRemoveFromMobile(checkbox);

            if (parentId) {
                // if this is a child, uncheck the parent
                let parent = sidebar.getCheckboxParent(parentId);
                sidebar.uncheckCheckboxAndRemoveFromMobile(parent);
            } else {
                // See if this is a parent and uncheck all children
                let myId = checkbox.val();
                sidebar.uncheckCheckboxAndRemoveFromMobile(sidebar.getCheckboxChildren(myId));
            }
        }

        // Update input container buttons
        sidebar.updateMobileOpenModalButtons();
    });
});

/* ******************************************************************** */
/*              Mobile: Expand or collapse mobile filters               */
/* ******************************************************************** */
$(function () {
    $(".core-search-results").on("click", '#core-search-mobile-filter-expand', function () {
        $(".core-search-results").addClass("mobile-filters-expanded");
        $("#core-search-mobile-filter-expand, #core-search-mobile-filter-collapse").attr("aria-expanded", "true");
        let inputs = $("#core-search-mobile-filters").find("input:not([type=hidden]), select");
        if (inputs) $(inputs[0]).trigger("focus");
    });
    $(".core-search-results").on("click", "#core-search-mobile-filter-collapse", function () {
        $(".core-search-results").removeClass("mobile-filters-expanded");
        $("#core-search-mobile-filter-expand, #core-search-mobile-filter-collapse").attr("aria-expanded", "false");
    })
});


/* ******************************************************************** */
/*       Mobile: Add checked/unchecked class to checkbox in sidebar     */
/* ******************************************************************** */
$(function () {
    $(".core-search-results").on("change", ".core-search-filter-selected-options .form-check-input, core-search-filter-unselected-options .form-check-input", function () {
        let checkbox = $(this);
        let formCheck = checkbox.closest('.core-search-form-check');
        formCheck.toggleClass('core-search-option-checked', checkbox.is(':checked'));

        // Update input container buttons
        let filterBox = checkbox.closest('.core-search-filter-box');
        let sidebar = new coreSearchSidebarFilter(filterBox);
        sidebar.updateMobileOpenModalButtons();
    });
});

/* ******************************************************************** */
/*       Mobile: Uncheck checkbox when remove input button clicked      */
/* ******************************************************************** */
$(".core-search-results").on("click", ".core-search-mobile-remove-input", function () {
    let checkbox = $(this).siblings('.form-check-input');

    // Update modal
    let modal = new coreSearchModal();

    // Move item from selected to unselected
    modal.moveItemFromSelectedToUnselected(checkbox);

    // Get sidebar object
    let sidebar = new coreSearchSidebarFilter(checkbox.closest('.core-search-filter-box'));

    // Uncheck checkbox
    sidebar.uncheckCheckboxAndRemoveFromMobile(checkbox);

    // See if there is a parent-child relationship to update
    let formCheck = checkbox.closest('.core-search-form-check');
    let parentId = formCheck.data('parent-id');

    if (parentId) {
        // if this is a child, uncheck the parent
        let parent = sidebar.getCheckboxParent(parentId);
        sidebar.uncheckCheckboxAndRemoveFromMobile(parent);
    } else {
        // See if this is a parent and uncheck all children
        let myId = checkbox.val();
        sidebar.uncheckCheckboxAndRemoveFromMobile(sidebar.getCheckboxChildren(myId));
    }

    // Update input container buttons
    sidebar.updateMobileOpenModalButtons();

    // Enable update buttons
    $('.core-search-filter-submit').prop('disabled', false);
});

/* ******************************************************************** */
/*            Mobile: Update Submit button when clicked                 */
/* ******************************************************************** */
$().on("submit", "#core-search-sidebar-form", function () {
    $('.core-search-filter-submit').prop('disabled', true).text('Updating...');
});


$(".core-search-results").on("click", ".core-search-filter-radio-options .core-search-form-check:not(.core-search-option-checked)", function () {
    let radio = $(this);
    let filterBox = radio.closest('.core-search-filter-box');

    // Remove checked class from everything
    filterBox.find('.core-search-option-checked').removeClass('core-search-option-checked');

    // Add back to selected radio
    let formCheck = radio.closest('.core-search-form-check');
    formCheck.addClass('core-search-option-checked');
});